import { locale, loadMessages } from 'devextreme/localization';
import frMessages from 'devextreme/localization/messages/fr.json';
import deMessages from 'devextreme/localization/messages/de.json';
import esMessages from 'devextreme/localization/messages/es.json';
import itMessages from 'devextreme/localization/messages/it.json';
import enMessages from 'devextreme/localization/messages/en.json';

export const reloadDevextremeMessages = (localeApp: string) => {
  type SupportedLanguages = 'fr' | 'de' | 'es' | 'it' | 'en';
  const messagesByLocale: Record<SupportedLanguages, any> = {
    fr: frMessages.fr,
    de: deMessages.de,
    es: esMessages.es,
    it: itMessages.it,
    en: enMessages.en
  };
  const getMessagesForLocale = (language: string) =>
    messagesByLocale[language as SupportedLanguages] || enMessages.en;
  const messages = getMessagesForLocale(localeApp);
  loadMessages(messages);
  locale(localeApp);
};
